import { useState } from "react";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { GamecardTable, GamecardSearchFilter } from "./component";
import { CreateGamecardModal } from "../../Modal/Gamecard/CreateGamecardModal";
import { GamecardsProps } from "./types";
import { GamecardPlan } from "../../../../features/auth/store/types/game-types";
import { EditGamecardModal } from "../../Modal/Gamecard/EditGameCardPlanModal";
import { DeleteGameCardPlanModal } from "../../Modal/Gamecard/DeleteGameCardPlan";

const Gamecard: React.FC<GamecardsProps> = ({
  gamecardPlans,
  loading,
  statusFilter,
  setStatusFilter,
  onGamecardPlanClick,
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
  countryFilter,
  setCountryFilter,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedGameCardPlan, setSelectedGameCardPlan] = useState<
    undefined | GamecardPlan
  >(undefined);
  const [gameCardPlanId, setGameCardPlanId] = useState<number | null>(null);

  const onEditClick = (gameCard: GamecardPlan) => {
    setSelectedGameCardPlan(gameCard);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setGameCardPlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="min-h-screen dark:bg-[#FFFFFF1A] w-full max-w-7xl mx-auto px-4 py-6">
        <InternalContainer headerText="Game Card Plans">
          <div className="flex flex-col">
            <GamecardSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
              categoryFilter={categoryFilter}
              onCategoryFilter={setCategoryFilter}
              countryFilter={countryFilter}
              onCountryFilter={setCountryFilter}
              sortBy={sortBy}
              onSortByChange={setSortBy}
              sortOrder={sortOrder}
              onSortOrderChange={setSortOrder}
            />
            <div className="border border-[#FFFFFF1A] overflow-x-auto">
              <GamecardTable
                gamecardPlans={gamecardPlans}
                statusFilter={statusFilter}
                searchTerm={searchTerm}
                onGamecardPlanClick={onGamecardPlanClick}
                onDeleteClick={onDeleteClick}
                onEditClick={onEditClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateGamecardModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditGamecardModal
          gameCardPlan={selectedGameCardPlan}
          isOpen={isEditModalOpen && selectedGameCardPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedGameCardPlan(undefined);
          }}
        />
        <DeleteGameCardPlanModal
          id={gameCardPlanId}
          isOpen={isDeleteModalOpen && gameCardPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setGameCardPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default Gamecard;
